import { reduce } from 'ramda'

import { SendersInfo } from 'app/dataTypes/transfer/senders'
import { createUID } from 'app/dataTypes/transfer/uid'

import type { Request } from '../../../../../index'


type SendersApi = Array<{
  id: number
  enabled: boolean
  type: 'Parent' | 'Student'
  name: string
  balance: string
  gender: 'male' | 'female'
  photo: string | null | ''
}>

export const convertResult = (data: SendersApi): SendersInfo => {
  return reduce((acc, val) => {
    const { id, enabled, type, name, balance: sBalance, gender, photo } = val
    const balance = parseFloat(sBalance)

    if (Number.isNaN(balance)) {
      console.warn(`Получен неверный баланс для ${name} (${id}), поэтому не будет участвовать в переводе`)
      return acc
    }

    const sender = {
      UID: createUID(String(id), type),
      enabled,
      type,
      name,
      balance,
      gender: gender === 'male' || gender === 'female' ? gender : 'androgynous' as const,
      photo: photo || null,
    }
    acc.senders.push(sender)
    if (sender.enabled) {
      acc.activeSenders.push(sender)
      acc.hasActiveSenders = true
    }

    return acc
  }, {
    senders: [],
    activeSenders: [],
    hasActiveSenders: false,
  } as SendersInfo, data)
}

export const GET_TRANSFER_SENDERS: Request<void, SendersInfo, void> = [
  'cabinet/cafeteria/payments/transfer/senders',
  'get',
  ['data', 'senders'],
]
